import { cx } from '@lastbrand/web-ui-styled-system/css'

import { FormattedPrice } from '@src/blocks/currency/currency.component'

import { OfferStyleKey } from './price-display-state'
import * as styles from './product-info-price-ds.styles'

export interface OfferPriceValueProps {
  formattedSubscriptionPrice?: string
  formattedFestivalOfferPrice?: string
  isSubscriptionOffer: boolean
  showNewPdpDesignV2?: boolean
  offerStyleKey: OfferStyleKey
}

const priceWrapperMainValueStylesToApply = {
  festivalOffer: [styles.festivalOfferCss],
  subscriptionOffer: [styles.subscriptionOfferCss],
  default: [],
}

const priceWrapperMainValueStylesToApplyPdpDesignV2 = {
  festivalOffer: [styles.festivalOfferNewDesignV2Css],
  subscriptionOffer: [styles.subscriptionOfferNewDesignV2Css],
  default: [],
}

function OfferPriceValue({
  formattedSubscriptionPrice,
  formattedFestivalOfferPrice,
  isSubscriptionOffer,
  showNewPdpDesignV2,
  offerStyleKey,
}: OfferPriceValueProps) {
  return (
    <div
      className={cx(
        styles.priceWrapperMainValueCss,
        styles.priceWrapperMainValueQpOfferCss,
        ...priceWrapperMainValueStylesToApply[offerStyleKey],
        ...priceWrapperMainValueStylesToApplyPdpDesignV2[showNewPdpDesignV2 ? offerStyleKey : 'default'],
      )}
    >
      <span className="festival_sale_price_selector_for_force_update">
        <FormattedPrice
          amount={
            isSubscriptionOffer && formattedSubscriptionPrice
              ? formattedSubscriptionPrice
              : formattedFestivalOfferPrice
                ? formattedFestivalOfferPrice
                : ''
          }
        />
      </span>
    </div>
  )
}

export default OfferPriceValue
